import styled from "styled-components";
import { mediaMinWidth } from "../../../utils/mediaQueriesTemplate";
import { defaultTheme } from "../../../../theme/theme";

export const NotificationsMenuWrapper = styled.div`
  margin: 4px 10px;
  color: #333;
  position: relative;
  border: 1px solid #fff;
  padding: 3px 7px 1px 7px;
  border-bottom: none;
  background: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 50px;
  transition: 0.1s ease-in-out;

  &.active {
    border: 1px solid #bdbdbd;
    border-bottom: none;
    height: 52px;
  }

  i {
    font-size: 2.15em !important;
    color: #e0e0e0;
  }

  &:hover {
    cursor: pointer;
  }

  ${mediaMinWidth.tablet`
    &.active {
      &:after {
        right: 11px;
      }
    }
  `}
`;

export const Counter = styled.span`
  font-size: 0.8em;
  top: 5px;
  padding: 0px 5px;
  right: 10px;
  font-family: sans-serif;
  background-color: ${defaultTheme.colors.mainLinkColor};
  border-radius: 16px;
  position: absolute;
  letter-spacing: 0.05em;
  font-weight: 700;
  margin-left: 5px;
  color: #fff;
  -webkit-text-stroke: 0px;
  pointer-events: none;
`;
